import React from 'react';
import { useNavigate } from 'react-router-dom';

import { usePatient } from 'hooks/usePatient/usePatient';
import { pageUrl } from 'utilities/pageUrl';

const CONTACT_PATIENT_NAVIGATORS_TEXT = 'Contact our patient navigators';

export const ContactPatientNavigatorLink = (): JSX.Element => {
  const { patient } = usePatient();
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate(`${pageUrl.messages({ categoryName: 'admin' })}`);
  };

  return (
    <>
      {patient ? (
        <a onClick={handleClick}>{CONTACT_PATIENT_NAVIGATORS_TEXT}</a>
      ) : (
        <a href="mailto:navigator@kindbody.com">{CONTACT_PATIENT_NAVIGATORS_TEXT}</a>
      )}
    </>
  );
};
